// extracted by mini-css-extract-plugin
export default {"soundButton":"SoundButton_soundButton__8t7W+"};